import { useState, useEffect, Fragment } from "react";

import FirebaseService from "../../sp-utils/firebaseService";
import NotificationService from "./NotificationService";
import appConstants from "../../sp-utils/app.constants";
import appUtils from "../../sp-utils/app.utils";
import NotificationContext from "../../layouts/components/navbar/NotificationContext";
import { UIPaths } from "../../router/UIPaths";

const AppNotificationContainer = ({ children }) => {
  const [notificationList, setNotificationList] = useState([]);
  const [demoNewsNotification,setDemoNewsNotification]= useState(null);
  const [showAllNotifications, setShowAllNotifications] = useState(false);
  const paginationDefaultState = { pageSize: 5, pageNumber: 1, totalRecords: 0 }
  const [pagingOptions, setPagingOptions] = useState(paginationDefaultState)
  const [sortingOptions, setSortingOptions] = useState({ sortByColumnName: 'createdOn', sortByColumnOrder: 1 })
  const searchOptions = {
        searchText: "",
        objectTypeCodeIDs: null,
        statusCodeIDs : [appConstants.notificationStatus.unRead]
      }


  const showNotification = (payload) => {

    let newsData = payload?.data?.object;
    try{
      newsData = JSON.parse(newsData)
      newsData.isNew = true
    }catch(e){
     console.log("errr parsing newsData---->",e)
     newsData ={}
    }    
    if(newsData && newsData.securityName != null ){
      saveDemoNewsNotification(newsData)
      payload.data.title = newsData.title
    }

    if (Notification.permission === appConstants.notification.browserPermission.granted) {
      const url = `${process.env.REACT_APP_UI_BASE_URL}/eqomply_logo.jpeg`;
      const notification = new Notification(payload.data.title, {
        body: payload.data.body,
        icon: url,
        data: payload.data,
        requireInteraction: true,
      });
      notification.onclick = () => handleNotificationClick(notification.data);

      if(newsData && newsData.securityName != null){
        notification.onclick = () => handleDemoNewsNotificationClick(notification.data,newsData);
      }
    }
    getNotificationList()

  };

  const handleNotificationClick = (data) => {

    if (data.notificationID) {
      updateNotificationStatus(data);
    }

    const parsedData = NotificationService.parseNotificationData(data);
    const targetUrl = NotificationService.getNotificationRedirectUrl(parsedData);


    if (targetUrl) {
      window.open(targetUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleDemoNewsNotificationClick = (data,newsData) => {

    if (data.notificationID) {
      updateNotificationStatus(data);
    }

    let url = UIPaths.entity.securities.detail.replace(
      ":securityID",
      newsData.securityID
    );

    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const onBackgroundServiceWorkerMessage = (data, payload) => {
    if (data) {
      handleNotificationClick(data)
      getNotificationList()
      updateDemoSecuritiesData(data)
    }
    if (payload && !appUtils.isUserLoggedIn()) {
      storeNotification(payload)
    } else if (payload && appUtils.isUserLoggedIn()) {
      showNotification(payload)
    }
  }

  const storeNotification = (payload) => {
    appUtils.setLocalStorage(appConstants.localStorageKey.webPush, JSON.stringify(payload));
  };

  const showStoredNotifications = () => {
    try {
      const storedNotification = appUtils.getLocalStorage(appConstants.localStorageKey.webPush, {});
      if (storedNotification && Object.keys(storedNotification).length) {
        showNotification(storedNotification)
      }
      appUtils.deleteLocalStorage(appConstants.localStorageKey.webPush)
    } catch (err) {
      console.log("error showing stored notification", err)
    }

  }

  const listenForSWMessages = (callback) => {
    if ("serviceWorker" in navigator) {
      const handler = (event) => {
        if (event.data?.type === appConstants.notification.PostMessage.navigate) {
          callback(event.data, null);
        }
        if (event.data?.type === appConstants.notification.PostMessage.store) {
          callback(null, event.data.payload);
        }
      };

      navigator.serviceWorker.addEventListener("message", handler);

      return () => {
        navigator.serviceWorker.removeEventListener("message", handler);
      };
    }
  };

  const getNotificationList = () => {
    const getNotificationListSuccessCb = (response) => {
      if (response.isSuccess) {
        let list = response.object.notificationList || [];
        list = list.sort((a, b) => a.createdOn < b.createdOn);
        setNotificationList(list);
      } else {
        getNotificationListErrorCb(response);
      }

    }
    const getNotificationListErrorCb = (response) => {
      setNotificationList([])
    }
    NotificationService.getNotificationList(searchOptions, pagingOptions, sortingOptions, getNotificationListSuccessCb, getNotificationListErrorCb);
  };

  const updateNotificationStatus = (item) => {
    const notificationIDList = Array.isArray(item) ? item.map(i => i.notificationID) : [item.notificationID];


    const updateNotificationStatusSuccessCb = (response) => {
      if (response.isSuccess) {
        getNotificationList()
      } else {
        updateNotificationStatusErrorCb()
      }
    }
    const updateNotificationStatusErrorCb = () => {
      console.log("error updating notification status...")
    }
    NotificationService.updateNotificationStatus(notificationIDList, appConstants.notificationStatus.read, updateNotificationStatusSuccessCb, updateNotificationStatusErrorCb);
  };

  const saveDemoNewsNotification = (newData) => {
    const key = appConstants.localStorageKey.securityDetail;

    let existingData = appUtils.getLocalStorage(key, []);
    if (!Array.isArray(existingData)) {
      existingData = [];
    }

    const alreadyExists = existingData.some(
      item => item.newsID === newData.newsID
    );

    let updatedData;

    if (alreadyExists) {
      updatedData = existingData; 
    } else {
      updatedData = [...existingData, newData];
    }

    appUtils.setLocalStorage(key, updatedData);

    setDemoNewsNotification(newData);
  } 
  // ----------------------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    // firebase foreground messages
    FirebaseService.listenForMessages((payload) => {
      const isLoggedIn = appUtils.isUserLoggedIn();
      if (isLoggedIn) {
        showNotification(payload);
      } else {
        const existing = appUtils.getLocalStorage(appConstants.localStorageKey.webPush);
        if (!existing || existing?.data?.notificationID !== payload?.data.notificationID) {
          storeNotification(payload);
        }
      }
    });

    // service Worker background messages
    const unsubscribe = listenForSWMessages(onBackgroundServiceWorkerMessage);

    // Cleanup SW listener
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);


  // ----------------------------------------------------------------------------------------------------------------------------------

  return (
    <Fragment>
      <NotificationContext.Provider
        value={{
          notificationList: notificationList,
          updateNotificationStatus: updateNotificationStatus,
          getNotificationList: getNotificationList,
          showStoredNotifications: showStoredNotifications,
          showAllNotifications: showAllNotifications,
          setShowAllNotifications: setShowAllNotifications,
          handleNotificationClick: handleNotificationClick,
          demoNewsNotification: demoNewsNotification,
          setDemoNewsNotification: setDemoNewsNotification
        }}
      >
        {children}
      </NotificationContext.Provider>
    </Fragment>
  );
};

export default AppNotificationContainer